/**
Directive that auto scrolls vertically when a dragged item gets close to the viewport edge.
Scroll speed depends on distance from threshold.
*/

const THRESHOLD = 100; // px

export default {
  bind(el) {
    const autoScroll = (clientY) => {
      if (clientY < THRESHOLD) {
        window.scrollTo(window.scrollX, window.scrollY - (THRESHOLD - clientY) / 10);
      }
      if (clientY > window.innerHeight - THRESHOLD) {
        window.scrollTo(window.scrollX, window.scrollY + (clientY - (window.innerHeight - THRESHOLD)) / 10);
      }
    };
    const onDragOver = ({ clientY }) => {
      // Firefox doesn't provide clientY on drag event, only on dragover, so this is a workaround for that.
      autoScroll(clientY);
    };
    el.ondrag = (evt) => {
      const { clientY } = evt;
      if (clientY === 0) {
        el.parentElement.ondragover = onDragOver;
      } else {
        autoScroll(clientY);
      }
    };
  },
};
